"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDecryptedItem = isDecryptedItem;
exports.isEncryptedItem = isEncryptedItem;
exports.isNotEncryptedItem = isNotEncryptedItem;
exports.isDeletedItem = isDeletedItem;
exports.isDecryptedOrDeletedItem = isDecryptedOrDeletedItem;
exports.isEncryptedErroredItem = isEncryptedErroredItem;
const TypeCheck_1 = require("../../Payload/Interfaces/TypeCheck");
function isDecryptedItem(item) {
    return 'payload' in item && (0, TypeCheck_1.isDecryptedPayload)(item.payload);
}
function isEncryptedItem(item) {
    return (0, TypeCheck_1.isEncryptedPayload)(item.payload);
}
function isNotEncryptedItem(item) {
    return !isEncryptedItem(item);
}
function isDeletedItem(item) {
    return (0, TypeCheck_1.isDeletedPayload)(item.payload);
}
function isDecryptedOrDeletedItem(item) {
    return isDecryptedItem(item) || isDeletedItem(item);
}
function isEncryptedErroredItem(item) {
    return isEncryptedItem(item) && item.errorDecrypting === true;
}
